import { Order as OrderType } from 'data/types/orders';
import { normalizeOrderType, normalizeOrderStatus } from 'model/global';
import formatName from 'utils/formatName';

type CustomOrderType = OrderType & {
  unseen: boolean;
  isUpdatingStatus: boolean;
};

export const normalizeOrder = (data: OrderType | CustomOrderType) => ({
  id: data.id,
  status: normalizeOrderStatus(data.status),
  type: normalizeOrderType(data.type),
  integration: {
    id: data.integration.id,
    name: data.integration.name,
    orderId: data.integrationOrderId,
    image: {
      src: data.integration.logo,
      alt: `${data.integration.name} logo`,
    },
  },
  brand: {
    id: data.brand.id,
    name: data.brand.name,
    image: {
      src: data.brand.logo,
      alt: `${data.brand.name} logo`,
    },
  },
  times: {
    delivery: data.times.delivery,
    ordered: data.times.ordered,
    pickup: data.times.pickup,
    updated: data.times.updated,
  },
  customer: {
    name: {
      firstName: data.customer.name.firstName,
      lastName: data.customer.name.lastName,
      displayName: formatName(data.customer.name.displayName),
    },
  },
  itemCount: data.itemCount,
  subtotal: parseInt(data.subtotal, 10) / 100,
  createdAt: data.createdAt as string,
  unseen: 'unseen' in data ? data.unseen : false,
  isUpdatingStatus: 'isUpdatingStatus' in data ? data.isUpdatingStatus : false,
});

export type Order = ReturnType<typeof normalizeOrder>;
